import { useNavigate } from 'react-router-dom';
import { MyOrder } from '../../interfaces/Order/MyOrder';
import { Pagination } from '../../interfaces/Pagination';
import { TableColumn } from '../DataTable/TableColumn';
import { TextColumn } from '../DataTable/TextColumn';
import { DateColumn } from '../DataTable/DateColumn';
import { PriceColumn } from '../DataTable/PriceColumn';
import { ButtonColumn } from '../DataTable/ButtonColumn';
import { DataTable } from '../DataTable/DataTable';

const columns: TableColumn<MyOrder>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'created-at',
    name: 'Tarih',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'total',
    name: 'Toplam',
    accessor: (row) => <PriceColumn value={row.orderTotal.raw} />,
  },
];

type OrdersTableProps = {
  orders: MyOrder[];
  totalCount: number;
  pagination?: Pagination;
  onPagination?: (newPagination: Pagination) => void;
  headless?: boolean;
  loading?: boolean;
};

export const OrdersTable = ({
  orders,
  totalCount,
  pagination,
  onPagination,
  headless,
  loading,
}: OrdersTableProps) => {
  const navigate = useNavigate();

  const detailsColumn: TableColumn<MyOrder> = {
    id: 'details',
    name: '',
    accessor: (row) => (
      <ButtonColumn
        label='Detay'
        onClick={() => navigate(`/hesabim/siparis-detayi/${row.id}`)}
      />
    ),
  };

  return (
    <DataTable
      columns={[...columns, detailsColumn]}
      totalCount={totalCount}
      rows={orders}
      limit={pagination?.pageSize}
      setLimit={(newLimit) => onPagination?.({ page: 0, pageSize: newLimit })}
      page={pagination?.page}
      setPage={(newPage) =>
        onPagination?.({ pageSize: 5, ...pagination, page: newPage })
      }
      hidePagination={!pagination}
      linkGenerator={(row) => `/hesabim/siparis-detayi/${row.id}`}
      headless={headless}
      loading={loading}
    />
  );
};
